"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveDropAuthorPfpProps {
  readonly drop: ApiDrop;
}
const WaveDropAuthorPfp: React.FC<WaveDropAuthorPfpProps> = t0 => {
  const $ = _c(14);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop.author.pfp) {
    t1 = drop.author.pfp ? resolveIpfsUrlSync(drop.author.pfp) : null;
    $[0] = drop.author.pfp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resolvedPfp = t1;
  const authorHandle = drop.author.handle;
  const profileHref = authorHandle ? `/${authorHandle}` : null;
  const tooltipUser = authorHandle ?? drop.author.id;
  let t2;
  if ($[2] !== authorHandle || $[3] !== resolvedPfp) {
    t2 = resolvedPfp ? <Image src={resolvedPfp} alt={authorHandle ? `${authorHandle}'s profile picture` : "Profile picture"} fill={true} sizes="44px" className="tw-object-contain tw-rounded-lg tw-bg-transparent" /> : <div className="tw-h-full tw-w-full tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10 tw-rounded-lg" />;
    $[2] = authorHandle;
    $[3] = resolvedPfp;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const avatarContent = t2;
  const handleClick = _temp;
  if (!profileHref) {
    let t3;
    if ($[5] !== avatarContent) {
      t3 = <div className="tw-relative tw-flex-shrink-0 tw-h-11 tw-w-11 tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden">{avatarContent}</div>;
      $[5] = avatarContent;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const t3 = `View ${tooltipUser}'s profile`;
  let t4;
  if ($[7] !== avatarContent || $[8] !== profileHref || $[9] !== t3) {
    t4 = <Link href={profileHref} prefetch={false} aria-label={t3} onClick={handleClick} className="tw-relative tw-flex-shrink-0 tw-h-11 tw-w-11 tw-rounded-lg tw-bg-iron-900 tw-overflow-hidden tw-block">{avatarContent}</Link>;
    $[7] = avatarContent;
    $[8] = profileHref;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4 || $[12] !== tooltipUser) {
    t5 = <UserProfileTooltipWrapper user={tooltipUser}>{t4}</UserProfileTooltipWrapper>;
    $[11] = t4;
    $[12] = tooltipUser;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default WaveDropAuthorPfp;
function _temp(event) {
  event.stopPropagation();
}